module.exports = __webpack_public_path__ + "media/images/admin/icons/alert-triangle-13dc803a868d27c481e860ea0d40b673.svg";